const makeId = () => Math.random().toString(36).slice(2);

export default makeId;
